import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import CountryItem from "./countryItem";

const TopCountries = () => {
  return (
    <Container>
      <Typography size="2xl" weight="medium" mb="2.4">
        Top Performing Countries
      </Typography>
      <ContriesContainer>
        <CountryItem
          highestStream="1033969"
          countryName="Nigeria"
          totalStreams="1033969"
        />
        <CountryItem
          highestStream="1033969"
          countryName="Ghana"
          totalStreams="834376"
        />
        <CountryItem
          highestStream="1033969"
          countryName="Angola"
          totalStreams="500367"
        />
        <CountryItem
          highestStream="1033969"
          countryName="Australia"
          totalStreams="101754"
        />
      </ContriesContainer>
    </Container>
  );
};

export default TopCountries;

const Container = styled.div`
  width: 100%;
  height: 100%;

  border-left: 0.5px solid ${Colors.grey600};
  padding: 1.6rem;
  @media only screen and (max-width: 769px) {
    border-top: 0.5px solid ${Colors.grey600};
    border-left: none;
  }
`;

const ContriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
